export default {"src":"/_next/static/media/counter-plus.7b2b3801.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};